import React from 'react';
import {faBoltLightning, faKey} from '@fortawesome/free-solid-svg-icons';
import {faHubspot, faSalesforce} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import zapierIcon from '../../libs/ui/src/assets/svg/zapier.svg';
import webhookIcon from '../../libs/ui/src/assets/svg/webhook.svg';
import rb2bIcon from '../../libs/ui/src/assets/svg/rb2b.svg';
import squidIcon from '../../libs/ui/src/assets/svg/squid.svg';
import slackIcon from '../../libs/ui/src/assets/svg/slack.svg';

export enum IntegrationType {
  SALESFORCE = 'salesforce',
  ZAPIER = 'zapier',
  HUBSPOT = 'hubspot',
  RB2B = 'rb2b',
  SQUID = 'squid',
  API_TOKEN = 'api_token',
  INSTANTLY = 'instantly',
  WEBHOOK = 'webhook',
  SLACK = 'slack',
}

export interface IntegrationItem {
  id: IntegrationType;
  name: string;
  description: string;
  isActive: boolean;
  icon: React.ReactNode | string;
  featureFlag?: string;
  clientFeatureFlag?: string;
}

export const integrationsList: IntegrationItem[] = [
  {
    id: IntegrationType.SALESFORCE,
    name: 'Salesforce',
    description: 'Connect your Salesforce CRM to sync contacts and activities',
    isActive: true,
    icon: <FontAwesomeIcon icon={faSalesforce} size="3x" color="#00a0e0" />,
    featureFlag: 'salesforceFeature',
  },
  {
    id: IntegrationType.ZAPIER,
    name: 'Zapier',
    description: 'Automate workflows and connect with 3000+ apps',
    isActive: false,
    icon: <img src={zapierIcon} alt="Zapier" style={{width: '48px', height: '48px'}} />,
    featureFlag: 'zapierFeature',
  },
  {
    id: IntegrationType.HUBSPOT,
    name: 'HubSpot',
    description: 'Integrate with HubSpot to manage your marketing campaigns',
    isActive: true,
    icon: <FontAwesomeIcon icon={faHubspot} size="3x" color="#fa6035" />,
    featureFlag: 'hubspotFeature',
  },
  {
    id: IntegrationType.RB2B,
    name: 'RB2B',
    description: 'Connect with RB2B for enhanced business features',
    isActive: false,
    icon: <img src={rb2bIcon} alt="RB2B" style={{width: '48px', height: '48px'}} />,
    featureFlag: 'rb2bFeature',
    clientFeatureFlag: 'rb2b_feature_enabled',
  },
  {
    id: IntegrationType.SQUID,
    name: 'Squid',
    description: 'Integrate with Squid for advanced functionality',
    isActive: false,
    icon: <img src={squidIcon} alt="Webhook" style={{width: '48px', height: '48px'}} />,
    featureFlag: 'squidFeature',
    clientFeatureFlag: 'asksquid_feature_enabled',
  },
  {
    id: IntegrationType.API_TOKEN,
    name: 'API Token',
    description: 'Manage your API tokens and access',
    isActive: false,
    icon: <FontAwesomeIcon icon={faKey} size="3x" color="#2197ff" />,
    featureFlag: 'apiSourceFeature',
  },
  {
    id: IntegrationType.INSTANTLY,
    name: 'Instantly',
    description: 'Connect with Instantly for email automation',
    isActive: false,
    icon: <FontAwesomeIcon icon={faBoltLightning} size="3x" color="#0281fb" />,
    clientFeatureFlag: 'instantly_feature',
  },
  {
    id: IntegrationType.WEBHOOK,
    name: 'Webhooks',
    description: 'Configure webhooks for real-time updates',
    isActive: false,
    icon: <img src={webhookIcon} alt="Webhook" style={{width: '48px', height: '48px'}} />,
  },
  {
    id: IntegrationType.SLACK,
    name: 'Slack',
    description: 'Connect Slack to receive notifications and automate workflows.',
    isActive: false,
    icon: <img src={slackIcon} alt="Webhook" style={{width: '48px', height: '48px'}} />,
  },
];
